// Utils and Constants
import { getItem } from "./localstorage";
import { LocalStorageKeys } from "../constants/GeneralConstants";

/**
 * Checks if the given organizationId is present in the provided array of orgIdsArray.
 * @param  organizationId - The ID of the organization to check.
 * @param  orgIdsArray - An array of organization IDs to search in.
 * @returns  Returns true if the organizationId is found in the orgIdsArray, otherwise false.
 */
export function checkIsOrgSpecific(organizationId, orgIdsArray = []) {
  return orgIdsArray.includes(organizationId);
}

// check Org is only API subscribed
export function checkIsOrgOnlyApiSubscribed() {
  const isOrgOnlyApiSubscribed = getItem(
    LocalStorageKeys.IS_ORG_ONLY_API_SUBSCRIPTION_ACTIVE
  );

  return JSON.parse(isOrgOnlyApiSubscribed);
}

// check Org is Planner and API subscribed
export function checkIsOrgPlannerAndApiSubscribed() {
  const isOrgPlannerAndApiSubscribed = getItem(
    LocalStorageKeys.IS_ORG_PLANNER_AND_API_SUBSCRIPTION_ACTIVE
  );

  return JSON.parse(isOrgPlannerAndApiSubscribed);
}
